// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"93f03fe5","105":"dfd239d5","413":"906f5a20","843":"7780b2eb","885":"4cea13cd"}[chunkId] + ".chunk.js";
};